import { motion } from "framer-motion";
import { Gavel, MonitorPlay, Database, Inbox, Image, ScrollText, UserCheck, Smartphone } from "lucide-react";

const FEATURES = [
  [Gavel, "Umpire scoring", "PIN or account login, point-by-point scoring from any phone."],
  [MonitorPlay, "Live TV boards", "Big-screen scoreboards and QR codes so spectators can follow along."],
  [Database, "Player Database", "Search verified players by rating, club, location and skill."],
  [Inbox, "Player messaging", "Email all players or one category, or send in-app messages to their inbox."],
  [Image, "Shareable Rating Card", "A branded 1080×1080 card players can download and post."],
  [UserCheck, "Verified profiles", "Email and Facebook verification on every player."],
  [ScrollText, "Audit-grade records", "Every rating and result is versioned and traceable."],
  [Smartphone, "Mobile-first", "Built to run courtside, on any screen size."],
];

export const FeatureGrid = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24" data-testid="feature-grid">
    <div className="mb-10">
      <span className="text-xs tracking-[0.25em] uppercase font-bold text-primary-c">And more</span>
      <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl mt-3">Built in, ready to use.</h2>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {FEATURES.map(([Icon, title, desc], i) => (
        <motion.div key={title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.4, delay: i * 0.05 }}
          className="rounded-2xl glow-border p-5 bg-surface hover:-translate-y-1 transition-transform"
          data-testid={`feature-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <Icon className="w-5 h-5 text-primary-c" />
          <div className="font-display font-bold mt-3">{title}</div>
          <p className="text-sm mt-1.5" style={{ color: "var(--text-2)" }}>{desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
